module.exports = __webpack_public_path__ + "static/img/2_3_2.f8609cd2.jpg";